import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RequestModel, RequestType} from "./request.model";
import {environment} from "../../../../environments/environment";
import {catchError, map} from "rxjs";
import {DomainCodeApiService} from "../../../services/domain_code/domain-code-api.service";
import {BackendListModel} from "../../../models/common/list.model";
import {DomainCode} from "../../../models/common/model";
import {LeadRequestService} from "./lead-request-service.service";

@Component({
    selector: 'app-request-page',
    templateUrl: './request-page.component.html',
    styleUrls: ['./request-page.component.scss']
})
export class RequestPageComponent implements OnInit {

    superLocationSourceLabel: string;
    superLocationDestinationLabel: string;

    // Models
    requestObj: RequestModel = new RequestModel();
    containerInfo: boolean;
    isShown: boolean = true;
    // Constants
    requestTypeBtns = [
        {
            name: 'One-Way',
            class: 'toggleBtn1',
            value: RequestType.ONE_WAY
        },
        {
            name: 'Trade',
            class: 'toggleBtn2',
            value: RequestType.BUY_SELL
        },
        {
            name: 'Lease',
            class: 'toggleBtn3',
            value: RequestType.LEASE
        },
    ]

    transactionTypeBtns: DomainCode[] = [];
    TYPE_LEASE = RequestType.LEASE;

    //API URLS
    portsListUrl = `${environment.baseApiUrl}/api/depot_master/location/?location_type_name=port&search=::search::`
    containerSizeTypeUrl = `${environment.baseApiUrl}/api/container_master/container_size_type/?search=::search::`

    // Elements
    @ViewChild('title')
    title: any;

    // Dropdown Lists
    containerConditionList: BackendListModel<DomainCode>;

    // Lifecycle Functions
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private domainService: DomainCodeApiService,
        private leadService: LeadRequestService
    ) {
        this.containerInfo = false;
    }

    menuOpen: boolean = false;

    showMenu() {
        this.menuOpen = !this.menuOpen;
    }

    ngOnInit(): void {
        this.getContainerCondition().subscribe();
        this.getTransactionTypes();
    }

    getRelevantTransactionTypes() {
        return this.transactionTypeBtns.filter((item) => {
            item.group == `LeadRequestTransactionTypes${this.requestObj.request_type}`;
        });
    }

    getTransactionTypes() {
        this.domainService.getByGroup(null, 'LeadRequestTransactionTypes').subscribe((response) => {
            this.transactionTypeBtns = response.results;
        });
    }

    // Helper Functions
    selectRequestType(requestType: RequestType) {
        this.router.navigate(['web-request/lead-request'], {
            queryParams: {
                'request_type': requestType,
            },
            queryParamsHandling: 'merge'
        });

        this.requestObj.request_type = requestType;

        if (requestType == RequestType.LEASE) {
            this.containerInfo = true;
        }
    }

    selectTransactionType(transactionType: string) {
        this.requestObj.transaction_type = transactionType;

        this.getSuperLocationLabels();
        // no need to set pol and pod if request type is buy_sell
        if (transactionType == RequestType.BUY_SELL) {
            this.containerInfo = true;
            // this.isShown = false;
        }

    }

    next() {
        if (this.containerInfo) {

            if (!this.requestObj.is_valid()) {
                return;
            }

            this.leadService.saveLeadRequest(this.requestObj.getLeadRequestData()).subscribe({
                next: (response) => {

                    this.router.navigate([this.requestObj.getDetailUrl()], {queryParams: {lead_id: response.id}});
                },
                error: (error) => {
                    this.requestObj.error = error.error;
                }
            });
        } else { // Only enters here when request type is one_way after selecting ports

            if (this.requestObj.validate_port_lists()) {
                this.containerInfo = true;
            }

        }
    }

    back() {

        setTimeout(() => {
            this.containerInfo = false;
        }, 1000)

        this.requestObj = new RequestModel();

        this.title.nativeElement.scrollIntoView({block: "center", behavior: "smooth"});

    }

    appendPol(port: any, index: number) {
        this.requestObj.appendPol(port, index);
    }

    appendPod(port: any, index: number) {
        this.requestObj.appendPod(port, index);
    }

    getContainerCondition(grp = 'ContainerCondition') {
        return this.domainService.getByGroup(grp).pipe(
            map(response => {
                if (!response) {
                    console.log("Could not fetch");
                } else {
                    this.containerConditionList = response;
                }
            }),
            catchError(error => {
                console.log("condition", error);
                return error;
            })
        );
    }

    // Get Location Labels
    getSuperLocationLabels() {
        switch (this.requestObj.request_type) {
            case 'one_way':
                this.superLocationSourceLabel = 'Pick-up Location*';
                this.superLocationDestinationLabel = 'Drop-off Location*';
                break;
            case 'buy_sell':
                if (this.requestObj.transaction_type == 'use') {
                    this.superLocationSourceLabel = 'Buy Location*';
                } else {
                    this.superLocationSourceLabel = 'Sell Location*';
                }
                break;
            case 'lease':
                this.superLocationSourceLabel = 'On-hire Location*';
                this.superLocationDestinationLabel = 'Off-hire Location*';
                break;
        }
    }
}
